module.exports = __webpack_public_path__ + "img/spider-black-widow.889ee98f.svg";